import { getterTree } from "typed-vuex";
import state from "./state";

/**
 * Tab module getters.
 */
const getters = getterTree(state, {});

export default getters;
